module.exports = __webpack_public_path__ + "img/Bodice-Front-B2-Ce-Db-Ed-Ga.cfb276e7.png";